import React from 'react';
import MissionCard from './sidebar/MissionCard';
import ReportCard from './sidebar/ReportCard';
import SessionExternalLinksCard from './sidebar/external-links/SessionExternalLinksCard';
import TranscriptCard from './sidebar/TranscriptCard';

/**
 * Side cards of a session. Outside links always show; the transcript cards follow
 * the transcript tab (or an unfinished transcript), the report card the official report.
 */
export default function SessionSidebar({
  tab, sessionId, session, transcript, transcriptReady, generation, gaps,
  report, publish, isOfficialReport, canGenerateReport, onGenerateReport, onAdvancedReport,
  primaryLanguage, reloadSession, notify,
}) {
  const transcriptCompleted = session.transcript_status === 'COMPLETED';
  return (
    <aside className="session-side">
      <SessionExternalLinksCard session={session} onSaved={reloadSession} onNotify={notify} />

      {(tab === 'transcript' || !transcriptCompleted) && (
        <TranscriptCard
          session={session}
          segments={transcript.segments}
          ready={transcriptReady}
          generation={generation}
          onFixSections={gaps.open}
          notify={notify}
        />
      )}

      {tab === 'transcript' && transcriptCompleted && (
        <MissionCard sessionId={sessionId} lang={session.transcript_language || primaryLanguage} notify={notify} />
      )}

      {tab === 'report' && isOfficialReport && transcriptReady && (
        <ReportCard
          session={session}
          report={report}
          publish={publish}
          canGenerate={canGenerateReport}
          onGenerate={onGenerateReport}
          onAdvanced={onAdvancedReport}
          primaryLanguage={primaryLanguage}
          notify={notify}
        />
      )}
    </aside>
  );
}
